import { computed, ComputedRef } from 'vue'

import { Coordinates } from '@collector/shared-ui-domain'
import {
  useLastIncident,
  useTeamSides,
} from '@desktop/views/Relation/composables'
import {
  useBlockades,
  useIncidentsTeamPossession,
} from '@desktop/views/Relation/Sports/composables'

export function useBallCoordinates(): {
  isBallCoordinatesVisible: ComputedRef<boolean>
  ballCoordinates: ComputedRef<Coordinates>
} {
  // composables
  const { currentFirstTeamSide } = useTeamSides()
  const { lastNonDeletedIncidentWithPosition } = useLastIncident()
  const { isPitchBlocked } = useBlockades()
  const { isLastIncidentDefaultPossession, isLastIncidentTeamInPossession } =
    useIncidentsTeamPossession()

  // methods
  function isLastIncidentParticipantInPossession(): boolean {
    if (!lastNonDeletedIncidentWithPosition.value) {
      return false
    }

    return isLastIncidentTeamInPossession()
  }

  // computed
  const isBallCoordinatesVisible = computed(
    () =>
      isLastIncidentParticipantInPossession() &&
      !isPitchBlocked() &&
      !isLastIncidentDefaultPossession(),
  )

  const ballCoordinates = computed(() => {
    const referencePoint = currentFirstTeamSide.value === 'away' ? 101 : 0

    return {
      x: Math.abs(
        referencePoint - (lastNonDeletedIncidentWithPosition.value?.x_pos ?? 1),
      ),
      y: Math.abs(
        referencePoint - (lastNonDeletedIncidentWithPosition.value?.y_pos ?? 1),
      ),
    }
  })

  return {
    isBallCoordinatesVisible,
    ballCoordinates,
  }
}
